import { gql } from '@apollo/client'

export default {
  getArtifactNineFive: () => gql`
    query GetArtifactNineFive($imageApid: ID!) {
      getArtifactNineFive(imageApid: $imageApid)
    }
  `,
  getArtifactParent: () => gql`
    query GetRmsId($ark: ID!) {
      getArtifactParent(ark: $ark)
    }
  `,
  getArtifactParentWithInactive: () => gql`
    query GetRmsId($ark: ID!) {
      getArtifactParentWithInactive(ark: $ark)
    }
  `,
  getSimpleGroupDetails: () => gql`
    fragment ImageViewerCoverageFields on ImageViewerCoverage {
      place {
        fullName
        id
        name
        published
      }
      recordTypes {
        apolloId
        date {
          fromTimestamp
          toTimestamp
          gedcomX
        }
        id
        name
      }
    }
    query SimpleGroupDetails(
      $groupIdOrArkId: String!
      $isVolumeSet: Boolean = false
      $includePlaceInformation: Boolean = true
    ) {
      group(
        groupIdOrArkId: $groupIdOrArkId
        sendBackApidsOnFail: true
        includePlaceInformation: $includePlaceInformation
      ) {
        active
        ancestralHall
        childCount
        childGroups(changeHistoryForFirstChildOnly: true) {
          childCount
          id
          imageViewerCoverages {
            ...ImageViewerCoverageFields
          }
          imageApids
          indexedChildCount
          internalData {
            cameraOperator
            cameraOperatorNumber
            id
            originalMediaNumber
            phoenixAcquisitionIds
          }
          metadata {
            archivalReferenceNumber
            createdDate {
              fromTimestamp
              gedcomX
            }
            creator
            custodian
            imageGroupNumber
            languages
            place
            title
            volume
            volumes
          }
          naturalGroupId
          placeInformation {
            repId
            fromYear
            toYear
            fromYearGCX
            toYearGCX
          }
        }
        currentWorkflowActions {
          name
          status
          parameters {
            name
            value
          }
        }
        firstAncestor
        id
        languages
        imageApids
        imageGroupNumber
        imageRework {
          cameraOperator {
            id
            name
          }
          status {
            status
            type
          }
          history {
            action
            date {
              fromTimestamp
            }
            state
            username
            notes
          }
        }
        imageReprocessing {
          action
          date {
            fromTimestamp
          }
        }
        imageViewerCoverages {
          ...ImageViewerCoverageFields
        }
        indexedChildCount
        internalData {
          cameraOperator
          cameraOperatorNumber
          originalMediaNumber
          phoenixAcquisitionIds
        }
        placeInformation {
          repId
          fromYear
          toYear
          fromYearGCX
          toYearGCX
        }
        metadata {
          archivalReferenceNumber
          creator
          custodian
          imageGroupNumber
          languages
          place
          title
          volume
          volumes
        }
        migrantAncestor
        naturalGroupId
        parentGroupId
        properties {
          name
          values
          type
        }
        siblingIdsWithChildren @skip(if: $isVolumeSet) {
          parentId
          childIds
        }
        title
        types
        volumes
        volumeSetTitle
        volumeSetTotalVolumes
      }
    }
  `,
  imageOrganizeStatus: () => gql`
    query ImageOrganizeStatus($rmsId: ID!) {
      imageOrganizeStatus(rmsId: $rmsId) {
        id
        divide {
          status
          userId
        }
        correctMetadata {
          status
          userId
        }
      }
    }
  `,
  imageOrganizeStatusList: () => gql`
    query ImageOrganizeStatusList($rmsIdList: [ID]!) {
      imageOrganizeStatusList(rmsIdList: $rmsIdList) {
        id
        divide {
          name
          status
          userId
          date {
            fromTimestamp
            toTimestamp
          }
        }
        correctMetadata {
          name
          status
          userId
          date {
            fromTimestamp
            toTimestamp
          }
        }
      }
    }
  `,
  naturalGroupAsyncStatus: () => gql`
    query naturalGroupAsyncStatus($location: String!) {
      naturalGroupAsyncStatus(location: $location) {
        percentComplete
      }
    }
  `,
  naturalGroupParentId: () => gql`
    query GetParentGroupId($childGroupIdOrArkId: String!) {
      naturalGroupParentId(childGroupIdOrArkId: $childGroupIdOrArkId)
    }
  `,
  parentGroups: gql`
    query ParentGroups($parentGroupType: GroupType, $rmsId: ID!) {
      groupParents(parentGroupType: $parentGroupType, rmsId: $rmsId) {
        id
        imageApids(limit: 1)
      }
    }
  `,
  reprocessData: () => gql`
    query GetGroup($groupIdOrArkId: String!) {
      group(groupIdOrArkId: $groupIdOrArkId) {
        imageReprocessing {
          action
          date {
            fromTimestamp
          }
        }
      }
    }
  `,
  reprocessRequest: () => gql`
    query ReprocessRequest($imageGroupNumber: [String!]!, $crop: Boolean!, $deskew: Boolean!, $sharpen: Boolean!) {
      reprocess(imageGroupNumber: $imageGroupNumber, crop: $crop, deskew: $deskew, sharpen: $sharpen) {
        status
      }
    }
  `,
  reworkData: () => gql`
    query ReworkData($actionName: String!, $notes: String, $groupId: String!) {
      rework(actionName: $actionName, notes: $notes, groupId: $groupId) {
        status
      }
    }
  `,
  standardsLanguages: () => gql`
    query Languages {
      standardsLanguages {
        id
        code
        language
      }
    }
  `,
  getGroupChangeHistory: () => gql`
    query GetGroupChangeHistory($groupId: String!) {
      getGroupHistory(groupIdOrArk: $groupId) {
        user {
          contactName
        }
        type
        opCode
        date {
          gedcomX
          fromTimestamp
        }
        coverages {
          place {
            fullName
            name
            id
          }
          recordTypes {
            apolloId
            id
            name
            date {
              fromTimestamp
              toTimestamp
              gedcomX
            }
          }
        }
        metadata {
          archivalReferenceNumber
          languages
          title
          volumes
          creator
        }
      }
    }
  `,
}
